import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { api } from '../../lib/api';

interface PortalLoginProps {
  onLogin: (user: any) => void;
}

const PortalLogin: React.FC<PortalLoginProps> = ({ onLogin }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!email || !password) { setError('Email and password are required.'); return; }
    setLoading(true);
    setError('');
    try {
      const data = await api.clientAuth.login(email, password);
      const user = { ...data.user, token: data.token };
      onLogin(user);
      navigate('/portal');
    } catch (err: any) {
      setError(err.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => { if (e.key === 'Enter') handleLogin(); };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#F8FAFC',
      backgroundImage: 'radial-gradient(ellipse at 20% 0%, rgba(13,148,136,0.08) 0%, transparent 50%), radial-gradient(ellipse at 80% 100%, rgba(59,130,246,0.06) 0%, transparent 50%)',
      padding: '20px',
    }}>
      <div style={{
        width: '100%', maxWidth: '420px', background: 'white',
        borderRadius: '16px', padding: '40px 36px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
        border: '1px solid #E2E8F0',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src="/logo.png" alt="VOP CRM" width={140} style={{ marginBottom: '16px' }} />
          <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 700, color: '#1E293B', fontFamily: 'var(--font-heading, "DM Sans", sans-serif)' }}>
            Client Portal
          </h1>
          <p style={{ margin: '4px 0 0', color: '#64748B', fontSize: '14px' }}>Valley of Peace Memorial Park</p>
        </div>

        {error && (
          <div style={{
            background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '8px',
            padding: '10px 14px', marginBottom: '16px', color: '#DC2626', fontSize: '13px',
            display: 'flex', alignItems: 'center', gap: '8px',
          }}>
            <Icon icon="solar:danger-circle-bold" width={16} />
            {error}
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }} onKeyDown={handleKeyDown}>
          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Email</label>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '10px', border: '1px solid #E2E8F0',
              borderRadius: '10px', padding: '10px 14px', background: '#F8FAFC',
              transition: 'border-color 0.15s',
            }}>
              <Icon icon="solar:letter-bold-duotone" width={18} style={{ color: '#94A3B8' }} />
              <input placeholder="you@email.com" type="email" value={email} onChange={e => setEmail(e.target.value)}
                style={{ flex: 1, border: 'none', outline: 'none', background: 'none', fontSize: '14px', color: '#1E293B', fontFamily: 'inherit' }} />
            </div>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Password</label>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '10px', border: '1px solid #E2E8F0',
              borderRadius: '10px', padding: '10px 14px', background: '#F8FAFC',
            }}>
              <Icon icon="solar:lock-bold-duotone" width={18} style={{ color: '#94A3B8' }} />
              <input placeholder="Enter your password" type="password" value={password} onChange={e => setPassword(e.target.value)}
                style={{ flex: 1, border: 'none', outline: 'none', background: 'none', fontSize: '14px', color: '#1E293B', fontFamily: 'inherit' }} />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Link to="/portal/forgot-password" style={{ color: '#0D9488', fontSize: '13px', textDecoration: 'none', fontWeight: 500 }}>
              Forgot password?
            </Link>
          </div>

          <button onClick={handleLogin} disabled={loading} style={{
            width: '100%', padding: '12px', border: 'none', borderRadius: '10px', cursor: 'pointer',
            background: 'linear-gradient(135deg, #0D9488 0%, #0F766E 100%)',
            color: 'white', fontWeight: 600, fontSize: '15px', fontFamily: 'inherit',
            opacity: loading ? 0.7 : 1, transition: 'opacity 0.15s',
          }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <span style={{ color: '#94A3B8', fontSize: '13px' }}>Staff member? </span>
          <Link to="/" style={{ color: '#0D9488', fontSize: '13px', textDecoration: 'none', fontWeight: 600 }}>
            Admin Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PortalLogin;
